import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { selectDaysUntilPasswordReset } from "@/redux/selectors/authSelectors";
import { showAlertWithActionAndCustomButton } from "@/redux/actions/alerts";

export function usePasswordResetAlert() {
  const dispatch = useDispatch();
  const history = useHistory();
  const daysUntilPasswordReset = useSelector(selectDaysUntilPasswordReset);

  useEffect(() => {
    if (daysUntilPasswordReset == null || daysUntilPasswordReset > 7) return;

    dispatch(
      showAlertWithActionAndCustomButton(
        `For security best practices and your protection aptihealth requires you to change your password every 90 days. Your password is set to expire in ${daysUntilPasswordReset} days.`,
        () => {
          history.push("/app/change-password");
        },
        "Change Password",
      ),
    );
  }, [daysUntilPasswordReset, dispatch, history]);
}
